class FileTreeNode {
    id: string;
    label: string;
    children: FileTreeNode[];
    leaf: boolean;
    diffType: string;
    tooltip: string;

    constructor({ id, label = null, diffType = null, tooltip = '', leaf=false }) {
        this.id = id;
        this.label = label;
        this.diffType = diffType;
        this.tooltip = tooltip;
        this.leaf = leaf;
        this.children = [];
    }

    addChild(node: FileTreeNode) {
        this.children.push(node);
        return node;
    }
}

export default FileTreeNode;
